import React, { Component } from 'react';
import TableRow from '../table/Row';
import TableColumn from '../table/Column';
import { actions } from 'actions';
import { SupplierStore } from 'stores/SupplierStore';

class LiveItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value || '',
    }
  }

  onChange = (evt) => {
    this.setState({value: evt.currentTarget.value});
  }

  saveTextField = (evt) => {
    var obj = {};
    obj[this.props.fieldKey] = evt.currentTarget.value;
    actions.saveSupplier(this.props.supplierId, obj);
    this.props.handleSave();
  }

  onClick = ({ currentTarget: { checked }}) => {
    this.setState({ value: checked });

    var obj = {};
    obj[this.props.fieldKey] = (+checked).toString()
    actions.saveSupplier(this.props.supplierId, obj);
    this.props.handleSave();
  }

  render() {
    return (
      <TableRow>
        <TableColumn><strong>{this.props.title}</strong></TableColumn>
        <TableColumn>
          <span className="pull-right">
              { this.props.type == 'text' &&
                  <input style={{ textAlign: "right", paddingRight: 5  }} type="text" onBlur={this.saveTextField} onChange={this.onChange} value={this.state.value} />
              }

              { this.props.type == 'checkbox' &&
                  <input type="checkbox" checked={!!+this.state.value} onChange={this.onClick} />

              }
          </span>
        </TableColumn>
      </TableRow>
    );
  }
}

export {LiveItem};
